module.exports = __webpack_public_path__ + "assets/img/101902.b91f229b.png";